export const getAggregationFromLastSingleProduct = (packagingPreference, newPackagingValue, lastSingleProductSelected) => {
    if (packagingPreference === "mix_n_match" &&
        newPackagingValue !== "mix_n_match" &&
        lastSingleProductSelected?.aggregations) {
        const aggregation = structuredClone(lastSingleProductSelected.aggregations);
        const { current } = lastSingleProductSelected;
        const { orderFrequency, packagingPreference } = current;
        aggregation[orderFrequency][packagingPreference] = current;
        return aggregation;
    }
    return undefined;
};
//# sourceMappingURL=getAggregationFromLastSingleProduct.js.map